import type { TFunction } from "i18next";

/**
 * What the centre's screens call a group: the name its therapist gave it, or
 * its size — never who is in it.
 *
 * The one place that decides it, for the caseload and the agenda alike. A
 * group without a name used to be saved under its members' first names, which
 * put people the centre may not hold on the administrator's screen. Its own
 * therapist still reads those names (`groupLabel` in the patient module); the
 * centre reads "Group (3 members)".
 *
 * `memberCount` is what the centre holds: the members it can see.
 */
export function centerGroupLabel(
    t: TFunction,
    displayName: string | null | undefined,
    memberCount: number
): string {
    return displayName || t("center.unnamedGroup", { count: memberCount });
}
